import {Grid, GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import {CreateAccessFormValidationSchema} from '../../formSchemas'
import {useFormContext, Controller, useWatch} from 'react-hook-form'
import {useTranslation} from '@/translations/i18n'
import {useGetProjectAccessCounters} from '@/features/projects/queries/useGetProjectAccessCounters'
import {
    StyledEventProjectAccessesCountersItem,
    StyledEventProjectAccessesCountersValue
} from '@/features/agenda/components/agenda-event-accesses-counters/style'
import {Switch} from '@/components/commons/switch/Switch'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'
import {InputHelpText} from '@/components/ui/input-help-text/InputHelpText'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Text} from '@/components/ui/text/Text'

export const AccessFormMissedAccess = () => {
    const {t} = useTranslation()
    const {control} = useFormContext<CreateAccessFormValidationSchema>()
    const projectId = useWatch({control, name: 'project.id'})
    const accessTypeId = useWatch({control, name: 'accessType.id'})

    const {
        data: projectAccessCounters,
        isLoading: isProjectAccessCountersLoading,
        isError: isProjectAccessCountersError,
        error: projectAccessCountersError
    } = useGetProjectAccessCounters({
        urlParams: {projectId, accessTypeId},
        options: {enabled: !!projectId && !!accessTypeId}
    })

    return (
        <GridItem spanColumn={2}>
            {isProjectAccessCountersLoading ? (
                <Flexbox>
                    <StyledEventProjectAccessesCountersItem>
                        <Skeleton width={150} height={24} />
                        <Skeleton width={24} height={24} />
                    </StyledEventProjectAccessesCountersItem>
                </Flexbox>
            ) : isProjectAccessCountersError ? (
                projectAccessCountersError?.response?.status == 404 ? (
                    <Text size="textXs" palette="neutral" shade="500">
                        {t('agenda:no_planned_access_found')}
                    </Text>
                ) : (
                    <InputHelpText error={t('errors:default')} />
                )
            ) : (
                projectAccessCounters &&
                projectAccessCounters.missed > 0 &&
                projectAccessCounters.withdrawn > 0 && (
                    <Grid columns={2} fullWidth>
                        <StyledEventProjectAccessesCountersItem palette="neutral" shade="600">
                            <span>{t('agenda:missed_accesses')}</span>
                            <StyledEventProjectAccessesCountersValue>
                                {projectAccessCounters?.missed + projectAccessCounters?.withdrawn}
                            </StyledEventProjectAccessesCountersValue>
                        </StyledEventProjectAccessesCountersItem>

                        <Flexbox fullWidth justify="end">
                            <Controller
                                control={control}
                                name="isARecovery"
                                render={({field}) => (
                                    <Switch
                                        size="sm"
                                        label={t('agenda:missed_accesses_switch_label')}
                                        checked={!!field.value}
                                        onChange={field.onChange}
                                    />
                                )}
                            />
                        </Flexbox>
                    </Grid>
                )
            )}
        </GridItem>
    )
}
